import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    const run = async () => {
      try {
        if (!sessionId) {
          navigate("/", { replace: true });
          return;
        }
        const res = await api.post("/auth/session", { session_id: sessionId });
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-neutral-300" data-testid="auth-callback-loading">
      <div className="font-serif text-3xl tracking-tight">Signing you in…</div>
    </div>
  );
}
